import { render, staticRenderFns } from "./ArtworkCreateChoiceModal.vue?vue&type=template&id=a49ec346&scoped=true"
import script from "./ArtworkCreateChoiceModal.vue?vue&type=script&lang=js"
export * from "./ArtworkCreateChoiceModal.vue?vue&type=script&lang=js"
import style0 from "./ArtworkCreateChoiceModal.vue?vue&type=style&index=0&id=a49ec346&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a49ec346",
  null
  
)

export default component.exports